import { render, staticRenderFns } from "./workHours.vue?vue&type=template&id=282e3467"
import script from "./workHours.vue?vue&type=script&lang=js"
export * from "./workHours.vue?vue&type=script&lang=js"
import style0 from "./workHours.vue?vue&type=style&index=0&id=282e3467&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports